import { z } from 'zod';
import { uuidSchema } from './common.schema';

export const DeviceSchema = z.object({
  device_id:            uuidSchema,
  agent_id:             uuidSchema,
  hospital_id:          uuidSchema,
  device_type:          z.string(),
  device_name:          z.string(),
  model:                z.string().nullable(),
  serial_number:        z.string().nullable(),
  location_description: z.string().nullable(),
  care_unit_id:         uuidSchema.nullable(),
  status:               z.string(),
  discovered_at:        z.string().nullable(),
  created_at:           z.string(),
  updated_at:           z.string(),
    mac_address:          z.string().nullable().optional(),
});

export type Device = z.infer<typeof DeviceSchema>;

// ── Scanner API contract types ────────────────────────────────────────────────

export const ScannerScanModeSchema = z.enum(['image', 'command', 'auto']);
export type ScannerScanMode = z.infer<typeof ScannerScanModeSchema>;

export const ScannerScanRequestSchema = z.object({
  tenantId:                  z.string(),
  deviceId:                  z.string(),
  userId:                    z.string(),
  scanMode:                  ScannerScanModeSchema.optional(),
  imageData:                 z.string().optional(),
  fallbackToImageOnFailure:  z.boolean().optional(),
  clientCorrelationId:       z.string().optional(),
  scanSessionId:             z.string().optional(),
  manualEntry:               z.boolean().optional(),
  context: z.object({
    workflow:  z.string().optional(),
    patientId: z.string().optional(),
    orderId:   z.string().optional(),
  }).optional(),
});
export type ScannerScanRequest = z.infer<typeof ScannerScanRequestSchema>;

// ── Device registration contract types ────────────────────────────────────────

export const AddDeviceInputSchema = z.object({
  agentId:             z.string(),
  deviceType:          z.string(),
  deviceName:          z.string(),
  macAddress:          z.string().optional(),
  model:               z.string().nullable().optional(),
  serialNumber:        z.string().nullable().optional(),
  locationDescription: z.string().nullable().optional(),
  status:              z.string().optional(),
  discoveredAt:        z.string().nullable().optional(),
  printerPort:         z.number().int().min(1).max(65535).nullable().optional(),
  dpi:                 z.number().int().positive().nullable().optional(),
  dpiSource:           z.string().max(50).nullable().optional(),
});
export type AddDeviceInput = z.infer<typeof AddDeviceInputSchema>;
